import { Store } from 'store/index';

const getLastQueryStringHash = (store: Store) => store.search.lastQueryStringHash;

export default getLastQueryStringHash;
